import React from 'react'
import PropTypes from 'prop-types'

/*
 ** This component can be used for cleanly rendering
 ** content created in WISIWYG content editor.
 ** Add className upon implementation
 */

const InnerHtml = ({ content, ...rest }) => (
  <div dangerouslySetInnerHTML={{ __html: content }} {...rest}></div>
)

InnerHtml.propTypes = {
  content: PropTypes.string, // a string containing one or more html elements
  rest: PropTypes.any,
}

export default InnerHtml
